/** `{{name}}` placeholders; unknown names render as empty strings. */
export function renderTemplate(template: string, vars: Record<string, string | number | null | undefined>): string {
  return template.replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi, (_m, name: string) => {
    const v = vars[name];
    return v === null || v === undefined ? '' : String(v);
  });
}

/** Placeholders a template uses (for the template editor). */
export function templateVariables(template: string): string[] {
  return [...new Set([...template.matchAll(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi)].map((m) => m[1]!))];
}

export const TEMPLATE_VARIABLES = ['firm_name', 'client_first_name', 'client_name', 'matter_title', 'matter_number', 'stage', 'lawyer_name', 'portal_link'] as const;
